import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import Drone from "./../../../images/drone.svg";
import "ol/ol.css";
import { Map, View } from "ol";
// import Geometry from 'ol/geom/Geometry';
import Polygon from "ol/geom/Polygon";
import Feature from "ol/Feature";
// import {getCenter} from 'ol/extent';
// import {extend} from 'ol/extent'
// import {
//    GeoJSON,
//    XYZ
// } from 'ol/format'
import {
  // LayerGroup,
  Image as ImageLayer,
  Tile as TileLayer,
  Vector as VectorLayer,
} from "ol/layer";
import {
  ImageWMS as ImageWMSSource,
  // OSM as OSMSource,
  // XYZ as XYZSource,
  TileImage as TileImageSource,
  // TileWMS as TileWMSSource,
  Vector as VectorSource,
} from "ol/source";
import {
  Style,
  // Fill as FillStyle,
  Stroke as StrokeStyle,
} from "ol/style";

import Projection from "ol/proj/Projection";
import { fromLonLat } from "ol/proj";

export class ProgramArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      program: this.props.prorgam,
      user: this.props.user,
      area: this.props.blockArea,
      coordinate: this.props.block,
      blockName: this.props.blockName,
      geoserver: process.env.REACT_APP_GEOSERVER,
      loc_id: null,
      loc_date: null,
      isChecked: false,
    };
  }
  componentDidMount() {
    // console.log('program area ', this.props.program, this.props.user)
    this.getDroneLayer(this.props.program, this.props.user);
  }
  getDroneImagery = () => {
    const polygon = new Polygon([
      this.state.coordinate.map((x) => fromLonLat([x.lng, x.lat])),
    ]);
    const vectorPolygon = new VectorLayer({
      visible: true,
      source: new VectorSource({
        features: [
          new Feature({
            geometry: polygon,
            name: this.state.blockName,
            area: this.state.area,
          }),
        ],
      }),
      style: [
        new Style({
          stroke: new StrokeStyle({
            color: "#445CFE",
            width: 3,
          }),
        }),
      ],
    });
    var features = vectorPolygon.getSource().getFeatures();
    var extent = features[0].values_.geometry.extent_;

    const droneLayer = new ImageLayer({
      source: new ImageWMSSource({
        url: this.state.geoserver,
        params: {
          projection: new Projection({
            code: "EPSG:4326",
            units: "m",
          }),
          // layers: 'jejak:drone_odm_orthophoto_dronebe6560f5228a48eea08d3c83c731cbc6_20201022',
          layers:
            "jejak:drone_odm_orthophoto_drone" +
            this.state.loc_id +
            "_" +
            this.state.loc_date,
          TILED: true,
        },
        serverType: "geoserver",
      }),
      visible: false,
    });

    this.map = new Map({
      // controls: DefaultControls().extend([
      //    new ZoomSlider(),
      //    new MousePosition(),
      //    new ScaleLine(),
      //    new OverviewMap()
      // ]),
      target: "map",
      layers: [
        // new TileLayer({
        //    source: new OSMSource(),
        // }),
        new TileLayer({
          source: new TileImageSource({
            url: "https://khms3.googleapis.com/kh?v=946&hl=id-ID&x={x}&y={y}&z={z}",
          }),
          visible: true,
        }),
        droneLayer,
        vectorPolygon,
      ],
      view: new View({
        zoom: 8,
      }),
    });
    this.map.getView().fit(extent, { padding: [100, 100, 100, 100] });
  };

  getDroneLayer = (idprogram, iduser) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/program/drone-layer/" +
          idprogram +
          "/" +
          iduser
      )
      .then((res) => {
        console.log("drone layer ", res.data.info_layers.drone);
        if (res.data.info_layers) {
          if (res.data.info_layers.drone[0] === undefined) {
            this.setState(
              {
                loc_id: null,
                loc_date: null,
                geoserver: process.env.REACT_APP_GEOSERVER,
              },
              () => {
                this.getDroneImagery();
              }
            );
          } else {
            this.setState(
              {
                loc_id: res.data.info_layers.drone[0].loc_id,
                loc_date: moment(
                  res.data.info_layers.drone[0].drone_date
                ).format("YYYYMMDD"),
                geoserver: process.env.REACT_APP_GEOSERVER,
              },
              () => {
                this.getDroneImagery();
              }
            );
          }
        } else {
          this.setState(
            {
              loc_id: null,
              loc_date: null,
              geoserver: process.env.REACT_APP_GEOSERVER,
            },
            () => {
              this.getDroneImagery();
            }
          );
        }
      });
  };

  showDrone = (e) => {
    // e.preventDefault()
    this.setState(
      {
        isChecked: !this.state.isChecked,
      },
      () => {
        if (this.state.isChecked === true) {
          this.map.getLayers().item(1).setVisible(true);
        } else {
          this.map.getLayers().item(1).setVisible(false);
        }
      }
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className="map-wrapper" style={{ position: "relative" }}>
          {this.state.loc_id ? (
            <React.Fragment>
              <div className="map-option">
                <div className="option-layer">
                  <div className="option-bg">
                    <small>Drone Layer</small>
                    <div className="row no-gutters justify-content-center">
                      <div className="col-auto">
                        <img src={Drone} alt="" />
                      </div>
                      <div className="col-auto">
                        <label
                          className="switch"
                          style={{
                            position: "relative",
                            top: "5px",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={this.state.isChecked}
                            onChange={this.showDrone}
                          />
                          <span className="slider slider-green round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : null}
          <div
            id="map"
            style={{
              height: "400px",
              width: "100%",
              position: "relative",
              background: "#f9f9f9",
            }}
          ></div>
        </div>
      </React.Fragment>
    );
  }
}

export default ProgramArea;
